import { RecordMaskResource } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const SpecimenRecordMask: RecordMaskResource = {
    name: {
        translatedString: {
            fr: 'Masque Specimen Reporter',
            en: 'Reporter Specimen Mask'
        },
        translatedId: null,
    },
    categories: [
        {
            label: 'editItemScreen.sections.identification',
            maskFields: [
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064d0",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "identifiers",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "SpecimenIdentifiers"
                            },
                            "listClass": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.complex.SpecimenIdentifiers"
                        },
                        entityFields: [
                            {
                                entityFieldId: "60a26f64c77cec3d940064cd",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "identifier",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "String"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.identifier",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.String",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964883",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064ce",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "identifierType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.identifierType",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964884",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064cf",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "principal",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "Boolean"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.principal",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.Boolean",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964886",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.identifiers",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964888",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 0,
                                "column": 0,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    },
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064cd",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "identifier",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "String"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.identifier",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.String",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964883",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064ce",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "identifierType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.identifierType",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964884",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064cf",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "principal",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "Boolean"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.identifiers.principal",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.Boolean",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964886",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        }
                    ],
                },
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064ed",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "specimenTitles",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "SpecimenTitles"
                            },
                            "listClass": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.complex.SpecimenTitles"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "60a26f64c77cec3d940064e8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "title",
                                "mandatorySystem": false,
                                "type": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.title",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964920",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064e9",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "titleType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.titleType",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964921",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064ea",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "language",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "language"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.language",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964922",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064eb",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "titleSource",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.titleSource",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964923",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                            {
                                entityFieldId: "60a26f64c77cec3d940064ec",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "isPrincipal",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "Boolean"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.isPrincipal",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.Boolean",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964925",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.specimenTitles",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964927",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    },
                    entityFields: [
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064e8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "title",
                                "mandatorySystem": false,
                                "type": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.title",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964920",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064e9",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "titleType",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.titleType",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964921",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064ea",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "language",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "language"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.language",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964922",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064eb",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "titleSource",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.titleSource",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964923",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                        {
                            entityField: {
                                entityFieldId: "60a26f64c77cec3d940064ec",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "specimen",
                                "schema": "identificationSpecimenSchema",
                                "name": "isPrincipal",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "Boolean"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "identificationSpecimenSchema.specimenTitles.isPrincipal",
                                "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.util.List|java.lang.Boolean",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1776429964925",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false,
                                "isIgnoreIndexation": false
                            }
                        },
                    ]
                },
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064d1",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "recolnatId",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "String"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.recolnatId",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|java.lang.String",
                        "isReadOnly": true,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964890",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    },
                },
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064e3",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "typeOfDeposit",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TranslatedString"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.typeOfDeposit",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|org.skinsoft.backend.types.translatedstring.TranslatedString",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964914",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    }
                },
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064cc",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "specimenType",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                            "type": "ThesaurusTerm",
                            "thesaurusIdentifier": "specimenType"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.specimenType",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964881",
                        "backwardSearchEnable": false,
                        "intermediateSearchEnableParameter": [
                            {
                                "row": 2,
                                "column": 0,
                                "workspace": "",
                                "target": ""
                            }
                        ],
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    }
                },
                {
                    entityField: {
                        entityFieldId: "60a26f64c77cec3d940064d6",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "specimen",
                        "schema": "identificationSpecimenSchema",
                        "name": "collectionType",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                            "type": "TranslatedString"
                        },
                        "entityFields": [],
                        "isChildren": false,
                        "isInList": false,
                        "path": "identificationSpecimenSchema.collectionType",
                        "pathType": "org.skinsoft.backend.schemas.specimen.identificationspecimenschema.IdentificationSpecimenSchema|org.skinsoft.backend.types.translatedstring.TranslatedString",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1,
                        "needId": false,
                        "usableForFacets": true,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1776429964896",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false,
                        "isIgnoreIndexation": false
                    }
                }
            ]
        }
    ]
}